import React,{ FC, useMemo } from "react"
import { WelfareMoldTyp } from "~src/service/welfare/welfare"
import styles from "./index.module.less"
interface WelfareColorType {
  border: string
  backgroundColor: string,
}

type WelfareDetailsColorType = Record<WelfareMoldTyp, WelfareColorType>

interface WelfareAboutProps {
  type: WelfareMoldTyp
}
const WelfareAbout: FC<WelfareAboutProps> = ({type}) => {
  const WelfareColor: WelfareDetailsColorType = useMemo(() => {
    return {
      "1": {
        border: "#00cd0033",
        backgroundColor: "#00CD00",
      },
      "2": {
        border: "#0B85FF33",
        backgroundColor: "#0B85FF",
      },
      "3": {
        border: "#f7d44133",
        backgroundColor: "#F4C500",
      }
    }
  }, [])
  const about = useMemo(() => {
    return {
      border: `12px solid rgba(255, 255, 255, 0)` ,
      backgroundColor: WelfareColor[type as WelfareMoldTyp]?.border
    }
  }, [WelfareColor, type])

  const aboutContent = useMemo(() => {
    return {
      background: WelfareColor[type as WelfareMoldTyp]?.backgroundColor,
    }
  }, [WelfareColor, type])
  return <div className={styles.about} style={about}>
    <div className={styles["about-content"]} style={aboutContent}>关于绿喵</div>
  </div>
}
export default WelfareAbout
